module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label i18n-label=\"Via Ferrata Teaser\" i18n-help=\"Via Ferrata Teaser Help\"></app-widgets-label> <app-i18n-textarea field=route.teaser main-lang=route.main_lang></app-i18n-textarea> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.historyLabel i18n-help=\"History Help\"></app-widgets-label> <app-i18n-textarea field=route.history main-lang=route.main_lang></app-i18n-textarea> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/general/partial_via_ferrata.html
// module id = 473
// module chunks = 0